import React, { useMemo, useState } from 'react';
import { Metrics } from './index';
import { selectDilDefinitionByName } from 'srs-middleware';

/**
 * ChartWrapper for the Bar Graph.
 *
 * @param widgetConfiguration
 * @param dimensions
 * @param data
 * @param selectedDefinitionName
 * @returns {*}
 * @constructor
 */
export function MetricsWrapper({ widgetConfiguration, dimensions, data, selectedDefinitionName }) {
	const [previous, setPrevious] = useState();

	// get the actual definition
	const selectedDefinition = useMemo(() => {
		return selectDilDefinitionByName(selectedDefinitionName);
	}, [selectedDefinitionName]);

	const convertedData = useMemo(() => {
		if (!data || !selectedDefinition || !data[selectedDefinition.systemDefinitionId]) return previous;

		const returnValue = Object.entries(data[selectedDefinition.systemDefinitionId]);

		setPrevious(returnValue);
		return returnValue;
	}, [data, selectedDefinition]);

	return <Metrics data={convertedData} dimensions={dimensions} widgetConfiguration={widgetConfiguration ?? {}} />;
}
